export const DADOS_RESUMIDOS_PF_DTO = {
  "cpf": "85122220425",
  "nome": "HVITRL XZIOLH ILXSZ",
  "dataNascimento": "19721205",
  "codSituacaoCadastral": 0,
  "descSituacaoCadastral": "Regular",
  "sexo": "Masculino",
  "anoObito": null
};
